import React, { useMemo } from 'react';
import useRestaurant from './useRestaurant';
import useDocument from './useDocument';
import { encodeJWT } from 'utils/webtoken';

const useGuestbookVersion = () => {
  const { apps, restaurantId } = useRestaurant();

  return {
    version: apps.includes('guestbook' as any) ? 'v02' : 'v01',
  };
};

export default useGuestbookVersion;
